module.exports = __webpack_public_path__ + "media/src/images/logos/paddle-9cee672a4043264d87a30724ddfda82b.png";